/* src/app/components/service/service-edit/service-edit.component.css */
/*# sourceMappingURL=service-edit.component.css.map */
